<template>
  <div class="right-center-list">
    <titleComponent titleName="长期巡查任务"></titleComponent>
    <div class="flex-just" style="position: relative;">
      <el-radio-group
        v-model="tabPosition"
        class="special-radio"
        size="mini"
      >
        <el-radio-button label="top">巡查明星</el-radio-button>
        <el-radio-button label="bottom">最高效区域</el-radio-button>
      </el-radio-group>
      <rankingDisplay
        v-if="tabPosition == 'top'"
        :rankingDataList="rankingDataList"
        :marginLeft="true"
        :isValue="true"
      ></rankingDisplay>
      <rankingDisplay
        v-if="tabPosition == 'bottom'"
        :rankingDataList="gaoxiaoTop3"
        :marginLeft="true"
        :isValue="true"
      ></rankingDisplay>
    </div>
    <div class="flex-just" style="margin-top:10px;">
      <!-- <div class="center-point">
        <titleInternal titleName="上报问题分布TOP5"></titleInternal>
        <div class="ranking">
          <div class="ranking-top flex-just">
            <div>
              <span class="top">排名</span>
              <span class="name">社区名称</span>
            </div>

            <span class="count">任务数/项</span>
          </div>
          <div
            class="ranking-cont"
            :class="'top' + index"
            v-for="(item, index) in componentData"
            :key="index"
          >
            <div class="flex-just center" style="margin-bottom: 20px">
              <div class="ranking-number">
                <img
                  :src="
                    require(`@/assets/daping/img-paiming${index > 3 ? 4 : index + 1}.svg`)
                  "
                />
                <span :class="['number', index < 9 ? 'numberOne' : 'numberTwo']">{{
                  index + 1
                }}</span>
                <div class="ranking-name">{{ item.label }}</div>
              </div>
              <div class="ranking-content">
                <div class="ranking-total">
                  <div class="flex rankingPosition">
                    <div
                      :class="[`ranking-count${index > 2 ? 3 : index}`]"
                      :style="{
                        width: (Number(item.value) / componentTotal) * 100 + '%',
                      }"
                    ></div>
                    <div class="ranking-countBlack"></div>
                  </div>
                </div>
              </div>
              <div class="ranking-count">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="center-point">
        <smallCycleDisposal
          :rlLineList="rlLineList"
          :wcLineList="wcLineList"
        ></smallCycleDisposal>
      </div>
      <div class="center-point center-pointOne">
        <titleInternal titleName="分层问题处置分布"></titleInternal>
        <div style="width: 311px; height: 230px">
          <wgEchart :options="fencengOneData" id="fencengOne"></wgEchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
import titleComponent from "@/pages/patrolScreenMini/components/title.vue";
import rankingDisplay from "@/pages/patrolScreenMini/components/ranking-display.vue";
import smallCycleDisposal from "@/pages/patrolScreenMini/components/right/smallCycleDisposal.vue";
import { extendBigScreenCqxxTj } from "@/api/daping.js";
import * as echarts from "echarts";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
    titleComponent,
    rankingDisplay,
    smallCycleDisposal,
  },
  data() {
    return {
      rankingDataList: [],
      gaoxiaoTop3: [],
      componentData: [],
      componentTotal: "",
      rlLineList: [],
      wcLineList: [],
      fencengOneData: {},
      tabPosition: "top",
    };
  },
  mounted() {
    this.extendBigScreenCqxxTj();
  },
  methods: {
    async extendBigScreenCqxxTj() {
      let res = await extendBigScreenCqxxTj();
      if (res.data.code == 200) {
        let data = res.data.data;
        this.rankingDataList = data && data.xcmxTop3;
        this.rankingDataList.forEach((item, index) => {
          item.img = require(`@/assets/daping/img-no${index + 1}.png`);
        });
        this.gaoxiaoTop3 = data && data.gaoxiaoTop3;
        this.gaoxiaoTop3.forEach((item, index) => {
          item.img = require(`@/assets/daping/img-no${index + 1}.png`);
        });
        this.componentData = data && data.xcmxTop5;
        this.componentData = this.componentData && this.componentData.slice(0, 5);
        this.componentTotal = this.componentData.reduce(function (acc, obj) {
          return acc + Number(obj.value);
        }, 0);
        // 责任确认时效
        this.rlLineList = data && data.rlLineList;
        // 整改完成平均时效
        this.wcLineList = data && data.wcLineList;
        this.optionsListData(data && data.levelRoleCountList);
      }
    },
    optionsListData(dataList) {
      dataList.forEach((item) => {
        item.name = item.label;
      });
      let total = dataList.reduce(function (acc, obj) {
        return acc + Number(obj.value);
      }, 0);
      var color = [
        "#46ABFF",
        "#01E8FE",
        "#FFBB66",
        "#63DAA1",
        "#EA9B86",
        "#F7B467",
        "#ACCEEA",
        "#DC614D",
      ];
      var seriesOption = [
        {
          name: "",
          type: "pie",
          radius: ["52%", "60%"],
          hoverAnimation: true,
          padAngle: 3,
          roseType: "area",
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ADC2D3",
                fontSzie: "14px",
                formatter: function (params) {
                  var percent = 0;
                  var total = 0;
                  for (var i = 0; i < dataList.length; i++) {
                    total += dataList[i].value;
                  }
                  percent = ((params.value / total) * 100).toFixed(0);
                  if (params.name !== "") {
                    return params.name + "\n" + "\n" + params.value;
                  } else {
                    return "";
                  }
                },
              },
              labelLine: {
                length: 10,
                length2: 30,
                show: true,
              },
            },
          },
          data: dataList,
        },
        {
          type: "pie",
          name: "内层细圆环",
          radius: ["46%", "52%"],
          hoverAnimation: false,
          clockWise: true,
          itemStyle: {
            normal: {
              color: "rgba(70,171,255,0.2)",
            },
          },
          label: {
            show: false,
          },
          tooltip: {
            trigger: 'none'
          },
          data: [0],
        },
        {
          type: "pie",
          name: "外层细圆环",
          radius: ["64%", "65%"],
          hoverAnimation: false,
          clockWise: true,
          itemStyle: {
            normal: {
              color: "#0d3260",
            },
          },
          label: {
            show: false,
          },
          tooltip: {
            trigger: 'none'
          },
          data: [0],
        },
      ];
      this.fencengOneData = {
        color: color,
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: `${total}项`, // 这里填写总数
            textAlign: "center",
            fill: "#E4F2FF", // 文字的颜色
            fontSize: 24,
          },
        },
        legend: {
          show: false,
        },
        series: seriesOption,
      };
    },
  },
};
</script>
<style scoped lang="less">
.right-center-list {
  width: 100%;
  height: 465px;
}
.flex-just {
  display: flex;
  justify-content: space-between;
}
.center {
  align-items: center;
}

.center-point {
  width: 404px;
  height: 269px;
  background: linear-gradient(0, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  margin-top: 8px;
  padding-top: 6px;
}

.center-pointOne {
  width: 311px;
}

.ranking-cont {
  .ranking-number {
    position: relative;
    display: flex;
    align-items: center;
    img {
      width: 31px;
      height: 31px;
    }
    .number {
      font-family: MiSans Demibold;
      font-weight: 600;
      font-size: 15px;
      color: #ffffff;
      position: absolute;
      top: 5px;
      left: 10px;
    }
    .numberTwo {
      left: 6px;
    }
    .ranking-name {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 18px;
      color: #f3f8ff;
      margin-left: 10px;
      width: 120px;
    }
  }
  .ranking-count {
    font-family: MiSans, MiSans;
    font-weight: 500;
    font-size: 18px;
    color: #e4f2ff;
  }
}
.flex {
  display: flex;
}
.ranking {
  width: 518px;
  height: 280px;
  padding: 6px 20px 10px;
  overflow-y: auto;
  .ranking-total {
    width: 206px;
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    position: relative;
  }
  .ranking-count0 {
    background: linear-gradient(90deg, rgba(247, 180, 103, 0) 0%, #f7b467 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
  .ranking-count1 {
    background: linear-gradient(90deg, rgba(0, 255, 239, 0) 0%, #00ffef 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
  .ranking-count2 {
    background: linear-gradient(90deg, rgba(0, 163, 255, 0) 0%, #00a3ff 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
  .ranking-count3,
  .ranking-count4 {
    background: linear-gradient(90deg, rgba(114, 141, 164, 0) 0%, #728da4 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
  .ranking-countBlack {
    width: 3px;
    height: 6px;
    background: #e1f4ff;
    box-shadow: 0px 0px 9px 2px rgba(135, 212, 255, 0.7);
  }
  .ranking-countTwo {
    background: linear-gradient(90deg, rgba(0, 163, 255, 0) 0%, #00a3ff 100%);
    border-radius: 2px 0px 0px 2px;
    width: 300px;
    height: 6px;
  }
}
.rankingPosition {
  width: 206px;
  position: absolute;
  top: 0;
  left: 0;
}

.ranking-top {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 15px;
  color: #6e8095;
  line-height: 20px;
  margin-bottom: 10px;
  .name {
    margin-left: 10px;
  }
}

.special-radio {
  position: absolute;
  margin-bottom: 0px !important;
  width: 160px;
  top: 44px;
  left: 20px;
  z-index: 999;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
    padding: 7px;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
    padding: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/right/right-center.vue